module.exports = __webpack_public_path__ + "static/terra-mattress-intro-e06213f455cc2cbf10cf2d09bb42ee51.mp4";